import { makeChartComp } from '../../../util/makeChartComp';
var TinyLineChart = makeChartComp('TinyLine');
export default TinyLineChart;
